import { ArrowRight, Flame, Mail, MessageCircle, Phone } from "lucide-react";
import { CONTACT, PHOTOS, waLink } from "../lib/brand";
import { trackWhatsApp } from "../lib/api";
import { useQuote } from "../context/QuoteContext";
import { PageHero } from "../components/site/PageHero";

const DESKS = [["General information, GeM & tenders", CONTACT.info], ["Sales, quotations & bulk orders", CONTACT.sales]];

export default function Contact() {
  const { openQuote } = useQuote();
  return (
    <>
      <PageHero eyebrow="Contact us" title="Let’s make your next response fleet ready." copy="Connect with the desk that can move your requirement forward." image={PHOTOS.hero} />
      <section className="section wrap contact-grid">
        <div className="contact-main">
          <p className="eyebrow">New Delhi headquarters</p><h2>One conversation can clarify the path.</h2>
          <div className="contact-address">
            <strong>ML FAB ENTERPRISES PRIVATE LIMITED</strong><span>{CONTACT.address}</span>
            <a href={CONTACT.tel} data-testid="contact-phone-link"><Phone /> {CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.info}`} data-testid="contact-email-link"><Mail /> {CONTACT.info}</a>
            <a href={`mailto:${CONTACT.sales}`} data-testid="contact-sales-email-link"><Mail /> {CONTACT.sales}</a>
            <a href={waLink()} target="_blank" rel="noreferrer" onClick={() => trackWhatsApp("contact-page")} data-testid="contact-whatsapp-link"><MessageCircle /> Chat on WhatsApp</a>
          </div>
          <button className="button button-orange" onClick={() => openQuote({ source: "contact-page" })} data-testid="contact-quote-button">Request a consultation <ArrowRight size={17} /></button>
        </div>
        <div className="map-placeholder" data-testid="map-placeholder"><div className="map-grid" /><span><span className="map-pin"><Flame /></span> Bakarwala, New Delhi</span><small>Google Maps location placeholder</small></div>
      </section>
      <section className="section slate"><div className="wrap departments">
        <div><p className="eyebrow">Official contacts</p><h2>Reach the right desk.</h2></div>
        <div className="department-list">{DESKS.map(([a, b], i) => <a href={`mailto:${b}`} key={b} data-testid={`department-email-${i}`}><span>{a}</span><strong>{b}</strong><ArrowRight /></a>)}</div>
      </div></section>
    </>
  );
}
